import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateBidWorkflowMutation,
  CreateBidWorkflowMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const CREATE_BID_WORKFLOW_MUTATION = graphql(`
  mutation createBidWorkflow(
    $createWorkflow: CreateWorkflow!
    $stageFilterRequest: WorkflowStageSearchRequest
  ) {
    createBidWorkflow(createNewWorkflow: $createWorkflow) {
      id
      isDefault
      transitions {
        id
        group
        order
        stage {
          id
          name
          color
          iconColor
          iconName
          bidCount(WorkflowStageSearchRequest: $stageFilterRequest)
        }
      }
    }
  }
`);

export function useCreateBidWorkflow(
  options: UseMutationOptions<
    CreateBidWorkflowMutation,
    unknown,
    CreateBidWorkflowMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(CREATE_BID_WORKFLOW_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["bidWorkflow"] });
      await queryClient.invalidateQueries({ queryKey: ["bids"] });

      options.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
  });

  return { data, ...rest };
}
